// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VPs7FdDzqNRSFTO9FNmQ {
    position: relative;
    width: 100%;
}



.o20BgapMqn88aOxGrmng {
    background: white;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 4px 0;
    min-width: 150px;
}

.LUf3ugNswykMHQUpAsVz {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #262626;
    transition: background-color 0.2s;
}

.LUf3ugNswykMHQUpAsVz:hover {
    background-color: #f5f5f5;
    color: #ff4d4f;
}

.iLXGplZ8wnd3Idowa9LQ {
    font-size: 14px;
} `, "",{"version":3,"sources":["webpack://./src/components/ChecklistInLeadCard/ChecklistContextMenu.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;;;AAIA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".container {\n    position: relative;\n    width: 100%;\n}\n\n\n\n.contextMenu {\n    background: white;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    padding: 4px 0;\n    min-width: 150px;\n}\n\n.contextMenuItem {\n    padding: 8px 12px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #262626;\n    transition: background-color 0.2s;\n}\n\n.contextMenuItem:hover {\n    background-color: #f5f5f5;\n    color: #ff4d4f;\n}\n\n.contextMenuIcon {\n    font-size: 14px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VPs7FdDzqNRSFTO9FNmQ`,
	"contextMenu": `o20BgapMqn88aOxGrmng`,
	"contextMenuItem": `LUf3ugNswykMHQUpAsVz`,
	"contextMenuIcon": `iLXGplZ8wnd3Idowa9LQ`
};
export default ___CSS_LOADER_EXPORT___;
